const initialState = {
	trigger: true
}

const SwipeReducer = (state = initialState, action) => {
	switch(action.type) {
		case "REMOVE_SWIPE":
			return {  trigger: false}
		default:
			return state
	}
}

export default SwipeReducer